import './App.css';
import "./components/Intro"
import Intro from './components/Intro';
import Explanation from './components/explanation';
import ThisEvent from './components/thisevent';
import Navbar from './components/navbar';
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import  Home from "./pages";
import  About from "./pages/about";
import Speakers from './pages/speakers';
import Enrollment from './pages/enrollment';
import SimpleSlider from './components/speaker-slider';
import FooterComp from './components/footer';

function App() {
  return (
    <div>
    <head> 
      <title>Condense Matter Ankara Colloqium</title>
    </head>
        <div className='bg'> 
        <div id='navbar'>
          <Router >
            <Navbar/>
              <Routes>
                <Route path='/' exact Component={Home} />
                <Route path='/about' exact Component={About} />
                <Route path='/enrollment' exact Component={Enrollment} />
                <Route path='/speakers' exact Component={Speakers} />
              </Routes>
          </Router>
        </div>
        
        <Intro />
        <div > <Explanation /></div>
        </div>



      <div id='thisevent'><ThisEvent/></div>
      <div id='speakerList'>
        <SimpleSlider></SimpleSlider>
      </div>
      <div><FooterComp/></div>
    </div>
  );
}

export default App;
